export default "__VITE_ASSET__DJXL0$RU__"